import * as React from "react";
import bgTop from "assets/images/top-sm.png";
import logo from "assets/images/logo.svg";
import logoMeta from "assets/images/metaverse-logo-sm.png";
import gemieLogo from "assets/images/genie.png";
import finalist from "assets/images/finalist-sm.png";
import buttonVote from "assets/images/vote-sm.svg";
import buttonVoteEn from "assets/images/vote-sm-en.svg";
import buttonDetail from "assets/images/button-detail.svg";
import buttonDetailEn from "assets/images/button-detail-en.svg";
import avatar1 from "assets/images/avatar1-sm.png";
import avatar2 from "assets/images/avatar2-sm.png";
import avatar3 from "assets/images/avatar3-sm.png";
import avatar4 from "assets/images/avatar4-sm.png";
import avatar5 from "assets/images/avatar5-sm.png";
import title from "assets/images/title-sm.png";
import titleEn from "assets/images/title-sm-en.svg";
import audition from "assets/images/audition-sm.png";
import bgFlow from "assets/images/bg-flow.svg";
import bgFlowEn from "assets/images/bg-flow-en.svg";
import titleFinalist from "assets/images/title-finalist-sm.png";
import bgFinalist from "assets/images/bg-finalist-sm.png";
import Preview from "./mobile/Preview";
import LanguageIcon from "@mui/icons-material/Language";
import { useTranslation } from "react-i18next";
import Footer from "./Footer";

function Header() {
  const { t, i18n } = useTranslation();
  const [language, setlanguage] = React.useState("en");
  const [showLanguage, setShowLanguage] = React.useState(false);

  React.useEffect(() => {
    const lang = localStorage.getItem("lang");
    lang === "jp" ? setlanguage("jp") : setlanguage("en");
    setTimeout(() => {
      setShowLanguage(true);
    }, 1000);
  }, [language]);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setlanguage(lang);
    localStorage.setItem("lang", lang);
  };

  const handleClick = () => {
    window.open("https://city-pop.tokyo/", "_blank");
  };

  return (
    <header className="flex gap-5 justify-between px-6 bg-purple-500 h-12">
      <Image
        loading="lazy"
        src={logo}
        alt="Placeholder image"
        className="my-auto w-[70px] cursor-pointer"
        onClick={handleClick}
      />
      {/* <img loading="lazy" src={menu} alt="Placeholder icon" /> */}
      {/* <Dropdown /> */}

      <div className="flex gap-4">
        <div className="flex m-auto language gap-1">
          {showLanguage && (
            <LanguageIcon fontSize="10px" className="lang-icon !w-10" />
          )}
          <button
            className={`button ${
              language !== "jp" ? "active" : ""
            } text-[10px]`}
            type="button"
            onClick={() => changeLanguage("jp")}
          >
            JP
          </button>
          <span className="devider text-[10px]"> / </span>
          <button
            className={`button ${
              !language.includes("en") ? "active" : ""
            } text-[10px]`}
            type="button"
            onClick={() => changeLanguage("en")}
          >
            EN
          </button>
        </div>
        <Image
          src={language === "en" ? buttonVoteEn : buttonVote}
          alt="Descriptive alt text for the second image"
          className="shrink-0 my-auto max-w-full w-[103px] cursor-pointer"
          onClick={LinkVoting}
        />
      </div>
    </header>
  );
}
const Image = ({ src, alt, className, onClick }) => (
  <img
    loading="lazy"
    src={src}
    alt={alt}
    className={className}
    onClick={onClick}
  />
);

const LinkVoting = () => {
  window.open("https://citypoptokyo.deform.cc/voting/?page_number=0", "_blank");
};

function FinalistCard({ name, image, buttonImage, scroll }) {
  const scrollUp = () => {
    const element = document.getElementById(name);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  return (
    <div className="mb-12 grid gap-4">
      <div className="justify-center px-4 whitespace-nowrap bg-violet-800 rounded-[48px]">
        {name}
      </div>
      <img
        loading="lazy"
        src={image}
        alt={`${name} finalist`}
        className="w-full aspect-square"
      />
      <img
        loading="lazy"
        src={buttonImage}
        alt="Vote button"
        className="self-center mx-auto w-[111px]"
        onClick={() => scrollUp()}
      />
    </div>
  );
}

function Finalists(props) {
  const { lang } = props;
  const isEn = lang === "en" ? true : false;
  const finalists = [
    {
      name: isEn ? "Kotora" : "小虎",
      image: avatar1,
      buttonImage: lang === "en" ? buttonDetailEn : buttonDetail,
      scroll: 3700,
    },
    {
      name: isEn ? "Suzu" : "すず",
      image: avatar2,
      buttonImage: lang === "en" ? buttonDetailEn : buttonDetail,
      scroll: 5000,
    },
    {
      name: isEn ? "Shinya" : "しんや",
      image: avatar3,
      buttonImage: lang === "en" ? buttonDetailEn : buttonDetail,
      scroll: 6300,
    },
    {
      name: isEn ? "Akane Naniwa" : "浪花明音　アカンネ〜",
      image: avatar4,
      buttonImage: lang === "en" ? buttonDetailEn : buttonDetail,
      scroll: 7500,
    },
    {
      name: isEn ? "ANGEL" : "あんじ",
      image: avatar5,
      buttonImage: lang === "en" ? buttonDetailEn : buttonDetail,
      scroll: 8900,
    },
  ];

  return (
    <section
      className="flex overflow-hidden relative flex-col items-center mt-6 pb-6 w-full text-center text-white"
      style={{
        background: `url(${bgFinalist})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <img
        loading="lazy"
        src={titleFinalist}
        alt="Vote now"
        className="mt-16"
      />
      <div className="flex relative flex-col self-stretch px-20 mt-8 w-full text-base font-semibold leading-6">
        {finalists.map((finalist, index) => (
          <FinalistCard
            key={index}
            name={finalist.name}
            image={finalist.image}
            buttonImage={finalist.buttonImage}
            scroll={finalist.scroll}
          />
        ))}
      </div>
      <img
        loading="lazy"
        src={lang === "en" ? buttonVoteEn : buttonVote}
        alt="Vote now"
        onClick={LinkVoting}
        className="mt-8 aspect-[4.55] max-w-[260px] w-[260px]"
      />
    </section>
  );
}

function HomeMobile() {
  const { t, i18n } = useTranslation();
  const [lang, setLang] = React.useState();
  React.useEffect(() => {
    setLang(localStorage.getItem("lang"));
  }, [localStorage.getItem("lang")]);
  return (
    <main className="flex flex-col mx-auto w-full bg-white">
      <Header />
      <div
        className="relative top-mobile-wrapper"
        style={{
          background: `url(${bgTop})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <img
          loading="lazy"
          src={logoMeta}
          alt="Divider 1"
          className="absolute right-2 top-2 cursor-pointer w-48"
        />
        <img
          loading="lazy"
          src={finalist}
          alt="Divider 1"
          className="ml-auto mr-0 mt-8 w-[95%]"
        />
        <div className="mx-auto text-center justify-center grid">
          <div className="flex gap-3 justify-center mb-2 items-center">
            <span className="hiragino text-white text-sm">Powered by</span>
            <img className="h-4" src={gemieLogo} alt="gemie" />
          </div>
          <h1 className="hiragino text-lg text-black font-semibold">
            {t("top_vode_decides")}
          </h1>
          <div className="bestten justify-center px-4 pb-1 mt-2 w-fit m-auto text-lg text-center text-white bg-purple-500 border-white border-solid">
            {t("top_nft_talent")}
          </div>
          <img
            loading="lazy"
            src={lang === "en" ? titleEn : title}
            alt="Divider 1"
            className="mx-auto"
          />
          <div className="flex gap-2 my-4 max-w-full font-semibold mx-auto">
            <div className="justify-center px-3 my-auto text-sm text-white bg-fuchsia-500">
              {t("top_periode")}
            </div>
            <div className="hiragino font-semibold text-xl text-black">
              2024.5.29~6.5
            </div>
          </div>
          <img
            loading="lazy"
            src={lang === "en" ? buttonVoteEn : buttonVote}
            alt="Divider 1"
            className="mx-auto"
            onClick={LinkVoting}
          />
        </div>
        <div className="arrow-wrapper absolute right-3 -bottom-16">
          <div className="arrow-team">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
      {/* <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/4acd4ac6bf4fd62f5aa57287b520f297d76036d19c18d3e883195ba9d103e089?apiKey=61e723b9be8047b897e51ffc5cec8321&" alt="Header background" className="object-cover absolute inset-0 size-full" /> */}

      <article className="flex z-10 flex-col justify-end px-6 mt-12 w-full text-xl font-semibold text-black">
        <img
          loading="lazy"
          src={audition}
          alt="Divider 1"
          className="mx-auto mb-6 w-[170px]"
        />
        <h1 className="self-center ml-3 text-center">{t("audition_talent")}</h1>
        <p className="justify-center self-center px-1 mt-1 w-fit text-center text-white bg-purple-500">
          {t("audition_decide")}
        </p>
        <p className="justify-center self-center px-1 mt-1 ml-3 text-center text-white bg-purple-500">
          {t("audition_voting")}
        </p>
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/02d572fff8a012575a1227072501cbfeadc8607c937c4ef530a7dd7fe801b83a?apiKey=61e723b9be8047b897e51ffc5cec8321&"
          alt="Winner prize"
          className="mt-6 w-full aspect-[1.72]"
        />
        <p className="mt-6 text-lg">
          {t("audition_winner")}
          <br />
          {t("audition_original")}
          <br />
          {t("audition_citypop")}
        </p>
        <p className="mt-4 text-sm leading-6">
          {t("audition_content1")}
          {t("audition_content2")}
          <br />
          {t("audition_content3")}
          <br />
          <br />
          {t("audition_content4")}
        </p>
        <div className="overflow-hidden relative flex-col items-start mt-6">
          <img
            loading="lazy"
            src={lang === "en" ? bgFlowEn : bgFlow}
            alt="Divider 1"
          />
        </div>
      </article>
      <Finalists lang={lang} />
      <Preview lang={lang} />
      <Footer />
    </main>
  );
}

export default HomeMobile;
